import React from "react";
import StyledToolTip from "../StyledToolTip";
import CustomerMergeIndicator from "./CustomerMergeIndicator";

interface CustomerNameCellProps {
  displayCustomerName?: string;
  customerName?: string;
}

// Grid customer cell: name and merge icon each own their tooltip (no cell-level tooltipField needed).
const CustomerNameCell = ({ displayCustomerName, customerName }: CustomerNameCellProps) => (
  <span>
    <StyledToolTip title={displayCustomerName || ""}>
      <span>{displayCustomerName}</span>
    </StyledToolTip>
    <CustomerMergeIndicator displayCustomerName={displayCustomerName} customerName={customerName} />
  </span>
);

// Shared AG-Grid cellRenderer for the common customer column (displayCustomerName vs customerName).
export const CustomerNameCellRenderer = ({ data }: { data: CustomerNameCellProps }) => (
  <CustomerNameCell displayCustomerName={data.displayCustomerName} customerName={data.customerName} />
);

export default CustomerNameCell;
